let DEBUG = localStorage.getItem('rt_debug') === '1';
export default DEBUG;
